import gql from "graphql-tag";

export const createNewSystemsMutation = gql`
  mutation CreateNewSystems($input: [CreateSystemInputType!]!) {
    createSystem(systemSettings: $input)
  }
`;
